import {subscribeChannel, publishChannel} from './channelUtils';

export function sendFullscreen(fullscreenOn) {
    publishChannel('fullscreen', { fullscreenOn });
}

export function listenFullscreen(callback) {
    
    return subscribeChannel(
        (event) => {

            const { tipo, payload } = event.data;

            if (tipo !== 'fullscreen') {
                return;
            }

            callback(payload);

        }
    );

}